"use client";

import { LoginRegistrationLayout } from "@/app/component/Landing";
import { useClientConfigProvider } from "@/app/config/client-config-provider";
import { EventLabels } from "@/app/constants/mix-panel-enums";
import { useMixPanel } from "@/app/context/mixPanelContext";
import { ReactNode, useEffect } from "react";

export default function RegisterLoginLayoutV2({
  children,
}: Readonly<{
  children: ReactNode;
}>) {
  const { config, getImagePath } = useClientConfigProvider();
  const { trackEvent, mixpanelInitialized } = useMixPanel();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const allSearchParams = Object.fromEntries(urlParams.entries());
    trackEvent(EventLabels.SL_Login_Register, {
      screen: "Landing",
      allSearchParams,
    });
  }, [mixpanelInitialized]);

  return <>{children}</>;
}
